import { render } from "./Stuff.vue?vue&type=template&id=d4d412ca"
import script from "./Stuff.vue?vue&type=script&lang=js"
export * from "./Stuff.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Mosolysziget/Mosolysziget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__